<template>
    <table class="catalogs">
        <thead>
        <tr>
            <th style="width: 60px">排序</th>
            <th style="width: 88px">章节序号</th>
            <th>章节标题</th>
            <th style="width: 88px">有无视频</th>
            <th style="width: 88px">有无作业</th>
            <th style="width: 107px">操作</th>
        </tr>
        </thead>
        <tbody ref="sortTable">
        <template v-for="(item, i) in catalogs">
            <!-- 使用 tr 包裹整个章节内容，包括子表格 -->
            <tr :key="item.id" class="chapter-container" :data-id="item.id">
                <td colspan="6" style="padding: 0; border: none;">
                    <table class="chapter-table" style="width: 100%;">
                        <tbody>
                        <tr class="item" :data-name="item.title" :data-id="item.id" style="display: flex;">
                            <td class="content">
                                <div class="icon drag-handle">
                                    <img class="sort" src="/assets/images/question-sort.png">
                                </div>
                                <img class="title" src="/assets/images/video/contents-title.png">
                            </td>
                            <td class="content">
                                <div class="type">第{{ getChineseNumber(i + 1) }}章</div>
                            </td>
                            <td class="content">
                                <div class="input-box">
                                    <div class="icon" @click="toggleExpand(item.id)">
                                        <img src="/assets/images/catalog-more.png"
                                             :style="{ transform: expandedItems[item.id] ? 'rotate(90deg)' : 'none', transition: 'transform 0.3s' }">
                                    </div>
                                    <a-input class="input" v-model="item.title" :data-id="item.id" @blur="parentBlur"
                                             placeholder="请输入章节标题"></a-input>
                                </div>
                            </td>
                            <td class="content"></td>
                            <td class="content"></td>
                            <td class="content">
                                <div class="add-btn" @click="addSubItem(item)"
                                     v-if="item.children && item.children != 'null' && item.children.length">添加小节
                                </div>
                                <div class="btn-box" v-else>
                                    <div class="op-btn" @click="addSubItem(item)">添加</div>
                                    <div class="line"></div>
                                    <div class="op-btn" @click="removeItem(item,i)">删除</div>
                                </div>
                            </td>
                        </tr>
                        
                        <!-- 嵌套表格 - 小节内容 -->
                        <tr v-if="expandedItems[item.id]" :key="`sub-${item.id}`" class="sub-table-row">
                            <td colspan="6" style="padding: 0;">
                                <div class="sub-table-container">
                                    <table class="sub-catalogs">
                                        <tbody :ref="`subSortTable-${item.id}`" :data-parent-id="item.id">
                                        <tr class="sub-item" v-for="(subItem, subIndex) in item.children"
                                            :key="subItem.id || subIndex" :data-id="subItem.id">
                                            <td class="sub-content" style="width: 60px;">
                                                <div class="icon drag-handle">
                                                    <img src="/assets/images/question-sort.png">
                                                </div>
                                            </td>
                                            <td class="sub-content" style="width: 88px;">
                                                <div class="type">第{{ subIndex + 1 }}节</div>
                                            </td>
                                            <td class="sub-content">
                                                <div>{{ subItem.title }}</div>
                                            </td>
                                            <td class="sub-content" style="width: 88px;">
                                                <div class="yes" v-if="subItem.file_id">有视频
                                                </div>
                                                <div class="no" v-else>无视频</div>
                                            </td>
                                            <td class="sub-content" style="width: 88px;">
                                                <div class="yes"
                                                     v-if="subItem.homeworks && subItem.homeworks.length">有作业
                                                </div>
                                                <div class="no" v-else>无作业</div>
                                            </td>
                                            <td class="sub-content" style="width: 107px;">
                                                <div class="btn-box">
                                                    <div class="op-btn" @click="editSubItem(item, subItem)">
                                                        编辑
                                                    </div>
                                                    <div class="line"></div>
                                                    <div class="op-btn"
                                                         @click="removeSubItem(item, subItem, subIndex)">删除
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </template>
        </tbody>
    </table>
</template>

<script>
import api from '@/repo/api';
import Sortable from "sortablejs";

export default {
    name: "Catalog",
    props: {
        course_id: {
            default: ''
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            catalogs: [],
            chCode: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'],
            expandedItems: {}, // 存储展开状态的对象
            subSortables: {} // 存储子表格的Sortable实例
        }
    },
    mounted() {
        this.init();
        this.initSortAble();
    },
    watch: {
        // 监听展开状态变化，初始化子表格的拖拽
        expandedItems: {
            handler(newVal) {
                this.$nextTick(() => {
                    for (const id in newVal) {
                        if (newVal[id]) {
                            this.initSubSortAble(id);
                        }
                    }
                });
            },
            deep: true
        }
    },
    methods: {
        init() {
            // 遍历list，将children转换为数组
            this.catalogs = this.list.map(item => ({
                ...item,
                children: item.children || []
            }));
            console.log(this.catalogs);
        },
        
        // 切换展开/收起状态
        toggleExpand(id) {
            this.$set(this.expandedItems, id, !this.expandedItems[id]);
            
            // 如果展开，初始化子表格拖拽
            if (this.expandedItems[id]) {
                this.$nextTick(() => {
                    this.initSubSortAble(id);
                });
            }
        },
        // 添加章节
        addParentHandle() {
            this.catalogs.push({id: 'parent' + (this.catalogs?.length), title: '', children: []});
            this.toggleExpand(this.catalogs[this.catalogs.length - 1].id);
        },
        // 章节标题失去焦点时触发
        parentBlur(e) {
            console.log(e.target.dataset.id);
            let title = e.target.value;
            if (!title) return;
            let index = this.catalogs.findIndex(i => i.id == e.target.dataset.id);
            if (index != -1) {
                // 保存
                this.saveParent(this.catalogs[index], (id) => {
                    // 新增或更新成功后，更新item的id
                    this.catalogs[index].id = id;
                });
            }
        },
        // 保存章节
        saveParent(item, callback) {
            console.log('saveParent', item);
            let params = {
                course_id: this.course_id, // 课程id
                title: item.title // 标题
            }
            // 如果item.id包含parent，说明是新增
            if (!item.id.toString().includes('parent')) {
                params.id = item.id;
            }
            // 新增或更新章节
            api.post('/ast-course-video/sync-chapter', params, res => {
                if (res.code == 0) {
                    // 调用回调函数
                    callback && callback(res.data.id);
                }
            })
        },
        // 删除章节
        removeItem(item, idx) {
            if (item.id.toString().includes('parent')) {
                this.catalogs.splice(idx, 1);
            } else {
                // 确认删除
                let title = "确定要删除这个章节吗？";
                this.$confirm({
                    title,
                    onOk: () => {
                        api.post('/ast-course-video/delete-item', {id: item.id, course_id: this.course_id}, res => {
                            if (res.code == 0) {
                                this.catalogs.splice(idx, 1);
                                this.$message.success('删除成功');
                            }
                        })
                    }
                })
            }
        },
        
        // 添加小节
        addSubItem(item) {
            if (item.title) {
                // 通过事件通知父组件添加小节
                this.$emit('addSubitem', item);
            } else {
                this.$message.error('请先输入章节标题');
            }
        },
        // 编辑小节
        editSubItem(item, subItem) {
            this.$emit('editSubitem', item, subItem);
        },
        // 删除小节
        removeSubItem(parentItem, subItem, subIndex) {
            let title = "确定要删除这个小节吗？";
            this.$confirm({
                title,
                onOk: () => {
                    this.catalogs.forEach(catalog => {
                        if (catalog.id == parentItem.id) {
                            
                            if (subItem.id) {
                                let params = {
                                    course_id: this.course_id, // 课程id
                                }
                                params.id = subItem.id;
                                api.post('/ast-course-video/delete-item', params, res => {
                                    if (res.code == 0) {
                                        // 删除成功后，从本地数据中删除
                                        catalog.children.splice(subIndex, 1);
                                        this.$message.success('删除成功');
                                    }
                                })
                            } else {
                                catalog.children.splice(subIndex, 1);
                                this.$message.success('删除成功');
                            }
                            
                        }
                    })
                }
            })
        },
        saveSubItem(isEdit, parentItem, subItem, callback) {
            let index = this.catalogs.findIndex(i => i.id == parentItem.id);
            if (index != -1) {
                if (isEdit) {
                    let subIndex = this.catalogs[index].children.findIndex(child => child.id == subItem.id);
                    if (subIndex != -1) {
                        this.catalogs[index].children[subIndex] = subItem;
                    }
                } else {
                    this.catalogs[index].children.push(subItem);
                }
                if (callback) {
                    callback();
                }
                console.log('expandedItems', this.expandedItems);
                // 展开当前章节,如果当前章节不是展开状态,则展开
                if (!this.expandedItems[parentItem.id]) {
                    this.toggleExpand(parentItem.id);
                }
                
            }
        },
        // 获取中文数字
        getChineseNumber(index) {
            if (index <= this.chCode.length) {
                return this.chCode[index - 1];
            }
            return index; // 超过20显示阿拉伯数字
        },
        
        initSortAble() {
            const tbody = this.$refs.sortTable;
            
            // 使用Sortable.js实现拖拽排序
            Sortable.create(tbody, {
                handle: '.drag-handle',
                animation: 150,
                ghostClass: 'sortable-ghost',
                chosenClass: 'sortable-chosen',
                dragClass: 'sortable-drag',
                filter: 'thead',
                onEnd: () => {
                    // 获取拖拽后的新位置
                    const newList = [];
                    tbody.querySelectorAll('tr.chapter-container').forEach(row => {
                        // 获取每个行的data-id属性
                        const id = row.getAttribute('data-id');
                        if (id) {
                            newList.push(id);
                        }
                    });
                    this.saveSort(newList);
                }
            });
        },
        
        initSubSortAble(parentId) {
            const refName = `subSortTable-${parentId}`;
            const tbodyRef = this.$refs[refName];
            
            // 检查ref是否存在且是数组，取第一个元素
            if (!tbodyRef || !Array.isArray(tbodyRef) || tbodyRef.length === 0) {
                return;
            }
            
            const tbody = tbodyRef[0];
            
            // 销毁现有的Sortable实例（如果存在）
            if (this.subSortables[parentId]) {
                this.subSortables[parentId].destroy();
            }
            
            // 使用Sortable.js实现子表格拖拽排序
            this.subSortables[parentId] = Sortable.create(tbody, {
                group: 'shared-sub-items',
                handle: '.drag-handle',
                animation: 150,
                ghostClass: 'sortable-ghost',
                chosenClass: 'sortable-chosen',
                dragClass: 'sortable-drag',
                onEnd: (evt) => {
                    // TODO 获取排序好的数据 构建结构 [{id:1,parent_id:1},{id:2,parent_id:1},{id:3,parent_id:1},...]
                    // evt.from 是拖拽起始的 tbody，evt.to 是拖拽放下的 tbody
                    const fromTbody = evt.from;
                    const toTbody = evt.to;
                    
                    // 获取源章节和目标章节的 ID
                    const fromParentId = fromTbody.getAttribute('data-parent-id');
                    const toParentId = toTbody.getAttribute('data-parent-id');
                    
                    const fromParentItem = this.catalogs.find(item => item.id == fromParentId);
                    const toParentItem = this.catalogs.find(item => item.id == toParentId);
                    
                    if (!fromParentItem || !toParentItem) return;
                    
                    // --- 1. 处理目标章节 (To) 的数据 ---
                    const toSortList = [];
                    toTbody.querySelectorAll('tr.sub-item').forEach(row => {
                        const id = row.getAttribute('data-id');
                        // 跨章节时，数据可能在 toParentItem 里，也可能在 fromParentItem 里
                        const subItem = toParentItem.children.find(item => item.id == id)
                            || fromParentItem.children.find(item => item.id == id);
                        if (subItem) {
                            toSortList.push(subItem);
                        }
                    });
                    
                    // 更新目标章节的 Vue 视图
                    this.$set(toParentItem, 'children', toSortList);
                    
                    // 构建目标章节的提交结构: [{id:1, parent_id:1}, ...]
                    let resultData = toSortList.map(item => ({
                        id: item.id,
                        parent_id: toParentId
                    }));
                    
                    
                    // --- 2. 处理源章节 (From) 的数据 (仅在跨章节拖拽时发生) ---
                    if (fromParentId !== toParentId) {
                        const fromSortList = [];
                        fromTbody.querySelectorAll('tr.sub-item').forEach(row => {
                            const id = row.getAttribute('data-id');
                            const subItem = fromParentItem.children.find(item => item.id == id);
                            if (subItem) {
                                fromSortList.push(subItem);
                            }
                        });
                        
                        // 更新源章节的 Vue 视图，把拖走的数据剔除
                        this.$set(fromParentItem, 'children', fromSortList);
                        
                        // 将源章节剩下的排序也加入到提交数据中，确保后端两边同步
                        const fromResultData = fromSortList.map(item => ({
                            id: item.id,
                            parent_id: fromParentId
                        }));
                        resultData = [...resultData, ...fromResultData];
                    }
                    
                    // --- 3. 提交给后端 ---
                    console.log('准备提交的排序数据:', resultData);
                    
                    let params = {
                        course_id: this.course_id,
                        sorts: resultData
                    }
                    
                    api.post('/ast-course-video/sort-videos-v2', params, res => {
                        if (res.code == 0) {
                            this.$message.success('排序成功');
                        }
                    })
                }
            });
        },
        
        saveSort(newList) {
            this.catalogs = newList.map(id => {
                return this.catalogs.find(item => item.id == id);
            })
            let sorts = this.catalogs.map(item => item.id);
            console.log('sorts', sorts);
            let params = {
                course_id: this.course_id,
                sorts
            }
            api.post('/ast-course-video/sort-videos', params, res => {
                if (res.code == 0) {
                    
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.catalogs {
    width: 100%;
    border-collapse: collapse;
    
    thead {
        border-bottom: 1px solid #EEEEEE;
        
        th {
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-weight: normal;
            color: #999999;
            
            &:nth-child(3) {
                text-align: left;
                padding-left: 16px;
            }
        }
    }
    
    .chapter-container {
        
        // 确保整个章节容器可以拖拽
        &.sortable-ghost {
            opacity: 0.5;
            background-color: #f8f8f8;
            
            .sub-table-row {
                display: none;
            }
        }
        
        &.sortable-chosen {
            background-color: #e6f7ff;
        }
        
        &.sortable-drag {
            opacity: 1;
            background-color: #fff;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            
            .sub-table-row {
                display: table-row;
            }
        }
    }
    
    .item {
        .content {
            height: 40px;
            line-height: 40px;
            color: #333333;
            font-size: 14px;
            margin: 10px 0;
            position: relative;
            
            .title {
                width: 32px;
                height: 32px;
                position: absolute;
                top: 0;
                left: 0;
            }
            
            .input-box {
                width: 100%;
                height: 40px;
                display: flex;
                align-items: center;
                border: 1px solid #EEEEEE;
                
                .icon {
                    width: 40px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    
                    .sort, img {
                        width: 16px;
                        height: 16px;
                    }
                }
                
                .input {
                    width: fit-content;
                    min-width: 100px;
                    border: none;
                    box-shadow: none;
                }
            }
            
            &:nth-child(1) {
                width: 60px;
                text-align: center;
                
                .icon {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    
                    img {
                        width: 16px;
                        height: 16px;
                        position: relative;
                        z-index: 100;
                    }
                }
            }
            
            &:nth-child(2) {
                width: 88px;
                
                .type {
                    width: 66px;
                    height: 40px;
                    background: #F7F7F7;
                    text-align: center;
                    margin: 0 auto;
                    color: #333333;
                    font-size: 14px;
                    font-weight: bold;
                }
            }
            
            &:nth-child(3) {
                flex: 1;
                padding-left: 16px;
            }
            
            &:nth-child(4) {
                width: 88px;
                text-align: center;
            }
            
            &:nth-child(5) {
                width: 88px;
                text-align: center;
            }
            
            &:nth-child(6) {
                width: 107px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                
                .add-btn {
                    width: 100%;
                    line-height: 40px;
                    color: #FBB03B;
                    text-align: center;
                    cursor: pointer;
                    
                    &:hover {
                        background-color: #fff8e8;
                    }
                }
            }
        }
    }
    
    .btn-box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        .op-btn {
            width: calc(50% - 1px);
            height: 100%;
            line-height: 40px;
            text-align: center;
            color: #FBB03B;
            font-size: 14px;
            cursor: pointer;
        }
        
        .line {
            width: 1px;
            height: 16px;
            background-color: #999999;
        }
        
        div:last-child {
            color: #F5606D;
        }
    }
    
    .sub-table-row {
        background-color: #fafafa;
        
        .sub-table-container {
            background-color: #f5f5f5;
        }
        
        .sub-catalogs {
            width: 100%;
            border-collapse: collapse;
            
            tbody {
                border: none;
                
            }
            
            .sub-item {
                background-color: white;
                
                &:last-child {
                    border-bottom: none;
                }
                
                .sub-content {
                    height: 40px;
                    line-height: 40px;
                    color: #333333;
                    font-size: 14px;
                    vertical-align: middle;
                    
                    .yes {
                        width: 74px;
                        height: 28px;
                        line-height: 28px;
                        color: #333333;
                        text-align: center;
                        background: #EDFAFD;
                        margin: 0 auto;
                    }
                    
                    .no {
                        width: 74px;
                        height: 28px;
                        line-height: 28px;
                        color: #333333;
                        text-align: center;
                        background: rgba(245, 96, 109, 0.08);
                        margin: 0 auto;
                    }
                    
                    .type {
                        width: 66px;
                        height: 40px;
                        text-align: center;
                        margin: 0 auto;
                        color: #333333;
                        font-size: 14px;
                    }
                    
                    .input-box {
                        width: fit-content;
                        height: 40px;
                        min-width: 100px;
                        display: flex;
                        align-items: center;
                        border: 1px solid #EEEEEE;
                        
                        .icon {
                            width: 40px;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            
                            img {
                                width: 16px;
                                height: 16px;
                            }
                        }
                        
                        .input {
                            width: fit-content;
                            min-width: 100px;
                            border: none;
                            box-shadow: none;
                        }
                    }
                    
                    &:nth-child(1) {
                        width: 60px;
                        text-align: center;
                        
                        .icon {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: move;
                            
                            img {
                                width: 16px;
                                height: 16px;
                            }
                        }
                    }
                    
                    &:nth-child(2) {
                        width: 88px;
                        text-align: center;
                    }
                    
                    &:nth-child(3) {
                        flex: 1;
                        padding-left: 16px;
                        text-align: left;
                        min-width: 150px; // 确保有最小宽度，避免内容过多时压缩太严重
                    }
                    
                    &:nth-child(4) {
                        width: 88px;
                        text-align: center;
                        
                        ::v-deep .ant-checkbox-wrapper {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: 40px;
                        }
                    }
                    
                    &:nth-child(5) {
                        width: 88px;
                        text-align: center;
                        
                        ::v-deep .ant-checkbox-wrapper {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: 40px;
                        }
                    }
                    
                    &:nth-child(6) {
                        width: 107px;
                        text-align: center;
                    }
                }
            }
        }
    }
}

// Sortable.js 样式
.sortable-ghost {
    opacity: 0.5;
    background-color: #f8f8f8;
}

.sortable-chosen {
    background-color: #e6f7ff;
}

.sortable-drag {
    opacity: 1;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
</style>